import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import get from 'lodash/get';
import React, { useEffect, useState } from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import { BlockLoadGroup } from 'widgets-v5/load-group';
import { ButtonGroup, PrimaryButton } from 'widgets-v5/buttons';
import Card from 'widgets-v5/card';
import CenterLayout from 'widgets-v5/center-layout';
/** import widgets in the section above, Sort Lines Ascending */

import { getApiErrorMessage } from 'utils/http/get-api-error-message';
import { login } from 'states/profile/actions';
import { redirectIfMissingToken, redirectLoggedInUserFromTokenLink } from 'common/token-link-guard';
import createHttp from 'utils/http';
/** import single application imports in the section above, Sort Lines Ascending */

const http = createHttp({ redirectOnFail: false });

/** Shown for invalid/expired magic-link tokens (Urban returns 403 with body `["Forbidden"]`). */
const EXPIRED_LINK_MESSAGE =
    'The sign-in link you used has expired or has already been used. Please request a new link.';

const EmailLoginEntry = props => {
    const [error, setError] = useState(null);
    useEffect(() => {
        const emailLoginToken = props.location.query.token;

        // Check if user is already logged in — redirect with warning toast if so
        if (redirectLoggedInUserFromTokenLink(props.profile, emailLoginToken)) {
            return;
        }

        // Validate token — redirect to home with error toast if missing or invalid
        if (redirectIfMissingToken({ query: { token: emailLoginToken } })) {
            return;
        }

        http.post('auth?populate=user,role,organization', { emailLoginToken }).then(
            data => {
                props.dispatch(login(data));
                browserHistory.push('/');
            },
            err => {
                const code = err?.code;
                if (code === 403 || code === 404) {
                    // Do not surface Urban body ["Forbidden"]; keep user-facing magic-link copy.
                    setError(EXPIRED_LINK_MESSAGE);
                    return;
                }

                if (code === 405) {
                    setError(
                        'Email link login is disabled for this account. Go back and login with password.'
                    );
                    return;
                }

                setError(getApiErrorMessage(err, 'Server error, please try again later'));
            }
        );
    }, []);

    return (
        <CenterLayout className="ef5-reset-password">
            <BlockLoadGroup isLoading={!error} size="large">
                <div>
                    <img className="ef5-reset-password__logo" src="/images/EngageFront-logo.png" />
                    <Card
                        className="ef5-reset-password__card"
                        title={error ? 'Sign-in Error' : 'Sign-in'}
                        footer={
                            <ButtonGroup>
                                <PrimaryButton
                                    text="Sign In Again"
                                    onClick={() => browserHistory.push('/')}
                                />
                            </ButtonGroup>
                        }
                    >
                        <p style={{ lineHeight: '16px' }}>{error}</p>
                    </Card>
                </div>
            </BlockLoadGroup>
        </CenterLayout>
    );
};

function select(state) {
    const profile = get(state, 'profile', {});
    return { profile };
}

export default connect(select)(EmailLoginEntry);
